var objActivityDayView = {
    /// <summary>
    /// This object contains all functions and properties for the activity day view
    /// </summary>

    _initializeObjActivityDayView: function (me) {
        /// <summary>
        /// This function builds the HTML structure for the activity day view and initializes all events
        /// </summary>

        me.dayReqId = 0;
        me.blockNextRowClick = false;
        objActivityDayView._buildHtml(me);
        objActivityDayView._initAllEvents(me);

        objActivityDayView._setHeights(me);
    },

    _buildHtml: function (me) {
        /// <summary>
        /// This function builds the HTML structure for the activity day view
        /// </summary>
        try {
            me.myHtml.activityDayview = me._setObj("div-activity-dayview", "vc-grid-margin-right float vc-grid-margin-bottom");
            // main menu with date box
            me.myHtml.activityDayview.menu = me._setObj("div-dayview-menu", "vc-grid-margin-right float vc-grid-margin-bottom");
            obj = me.myHtml.activityDayview.menu;
            obj.css({ width: me.myRoot.width(), display: "flex", justifyContent: "space-between", alignItems: "flex-end" });

            // menu items
            obj.btnNew = me._setObj("btn-new", "button-toggle").html(me.specific.resources.new).css({ "width": "100px" }).button();
            obj.dateBox = me._setObj("m-date-dayview", "optionbox vc-grid-margin-right");
            obj.append(obj.dateBox, obj.btnNew);

            // table / list of activities
            me.myHtml.activityDayview.list = me._setObj("div-dayview-list", "vc-grid-margin-right float vc-grid-margin-bottom");
            obj = me.myHtml.activityDayview.list;
            obj.wrapper = me._setWrapper("div-dayview-list-wrapper", "vc-list");
            obj.header = me._setListHeader("div-dayview-list-header");
            var line = me._setListItem();         
            line.column.append(me._setListElement("", "col0").html(me.specific.resources.periodOfTime).css("width", "8%").attr("title", me.specific.resources.periodOfTime));
            line.column.append(me._setListElement("", "col1").html(me.specific.resources.duration + " (h)").css("width", "5%").attr("title", me.specific.resources.duration + " (h)"));
            
            line.column.append(me._setListElement("", "col3").html(me.specific.resources.project).css("width", "12%").attr("title", me.specific.resources.project));
            line.column.append(me._setListElement("", "col2").html(me.specific.resources.ticket).css("width", "5%").attr("title", me.specific.resources.ticket));
            line.column.append(me._setListElement("", "col4").html(me.specific.resources.description).css("width", "65%").attr("title", me.specific.resources.description));
            line.column.append(me._setListElement("", "col5").html("").css("width", "5%"));
            obj.header.append(line.item);
            obj.data = me._setObj("", "lst-day-entries vc-list-table");
            obj.footer = me._setObj("div-dayview-list-footer", "vc-list-footer");

            obj.wrapper.append(obj.header, obj.data, obj.footer);
            obj.append(obj.wrapper);

            me.myHtml.activityDayview.append(me.myHtml.activityDayview.menu, me.myHtml.activityDayview.list); //, me.myHtml.dateBoxDayview.list);
            me.myHtml.content.append(me.myHtml.activityDayview);

        } catch (e) { me._writeErr(e); }
    },



    _setHeights: function (me) {

        var widgetH = me.myRoot.height();
        var topMenuH = me.fnd("#div-topmenu").outerHeight(true);
        var contentH = widgetH - topMenuH;

        me.fnd("#div-activity-dayview").outerHeight(contentH).css("width", "100%");

        var listMenuH = me.fnd("#m-date-dayview").outerHeight(true) || 0;
        var wrapperMaxH = contentH - listMenuH - 20;
        me.fnd("#div-dayview-list").outerHeight(wrapperMaxH).css("width", "100%");

        var headerH = me.fnd("#div-dayview-list-header").outerHeight(true) || 0;
        var footerH = me.fnd("#div-dayview-list-footer").outerHeight(true) || 0;

        // max height of list area
        var maxListH = Math.max(0, wrapperMaxH - 2 - headerH - footerH);

        var list = me.fnd(".lst-day-entries");

        // reset before measuring
        list.css({ height: "", "max-height": "", "overflow-y": "hidden" });

        // max height of list area (content space)
        var early = 12;
        var effectiveMax = Math.max(0, Math.floor(maxListH) - early);

        // set height of list
        list.height(effectiveMax).css({ "max-height": effectiveMax + "px", "overflow-y": "auto" });

        // decide scrollbar based on real rendered geometry
        var el = list.get(0);
        var tol = 1;
        var needsScroll = el ? (el.scrollHeight > el.clientHeight + tol) : false;

        if (!needsScroll) {
            list.css({ "overflow-y": "hidden" });
        }

        // wrapper height should match the height we SET (stable)
        var finalWrapperH = headerH + footerH + effectiveMax;
        finalWrapperH = Math.min(finalWrapperH, wrapperMaxH);
        me.fnd("#div-dayview-list-wrapper").outerHeight(finalWrapperH);
    },

    _initAllEvents: function (me) {
        /// <summary>
        /// This function initializes all events for the activity day view
        /// </summary>

        try {

            // set events for the date box 
            me.myHtml.activityDayview.menu.dateBox.calSingle = $("<div>").attr("id", "div-date-single");
            me.myHtml.activityDayview.menu.dateBox.calSingle.vcDate({
                mode: "Single", align: "right", interval: 1, langID: me.settings.userLangIDForCulture || me.specific.userLangID, callback: function (obj) {
                    me.myStatus.dateStart = obj.dateRange.from;
                    me.myStatus.dateEnd = obj.dateRange.to;
                    objActivityDayView._generateDayview(me);
                }
            });

            me.myHtml.activityDayview.menu.dateBox.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [{ button: me.specific.resources.date, clickable: true, content: me.myHtml.activityDayview.menu.dateBox.calSingle, isList: false }], callback: function () { }
            });

            me.myHtml.activityDayview.menu.btnNew.on("click", function () {
                me.myStatus.editMode = false;
                me.myStatus.editAId = -1;
                var date = me.myHtml.activityDayview.menu.dateBox.calSingle.vcDate("getDate"); 
                objActivityEdit._addActivityBtnNew(me, date.from);
            });


            // if user selects a list item, the info of selected row shall be overtaken in the edit form
            me.myHtml.activityDayview.list.data.off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) {
                if ($(this).hasClass("vc-add-act-row")) return; // AddRow clicked - is handled directly during adding the row

                if (me.blockNextRowClick || $(e.target).closest(".no-row-edit, .time-editor, .time-editor *," + " .time-cell .time-display, .icon-time-ok, .icon-time-cancel, .icon-delete").length) {
                    me.blockNextRowClick = false;
                    return;
                }

                var idx = $(this).data("index");
                var clickedRow = me.myStatus.allDailyActivities.rows[idx];

                if (!clickedRow) return;

                me.myStatus.editMode = true;
                me.myStatus.editAId = clickedRow.id;
                me.myStatus.editSource = "dayview";
                me.myStatus.editIndex = idx;
                objActivityEdit._editExistingActivity(me, clickedRow);

            });

            // Delete icon click handler
            me.myHtml.activityDayview.list.data.off("click", ".icon-delete").on("click", ".icon-delete", function (e) {
                e.stopPropagation(); // block row click event

                const index = $(this).data("index");
                const rowData = me.myStatus.allDailyActivities.rows[index];
                if (!rowData) return;
                if (rowData.billingdate || rowData.accountingtime) return; // billed items cannot be deleted

                me.myHtml.activityDayview.css("opacity", 0.2);
                me.openAskDialog(me.specific.resources.deleteEntry + "?",
                    { my: 'center', at: 'center', of: window },
                    function () {
                        me.updateData({ changeTypeId: 3, ActivityId: rowData.id }, function (result) {
                            objActivityDayView._generateDayview(me);
                            me.myHtml.activityDayview.css("opacity", 1);
                        });
                    },
                    function () {
                        me.myHtml.activityDayview.css("opacity", 1);
                        return true;
                    });
                
            });

            me.myHtml.activityDayview.list.data.off("click", ".desc-toggle").on("click", ".desc-toggle", function (e) {
                e.stopPropagation();
                var btn = $(this);
                var wrap = btn.prev(".desc-wrap");
                var expanded = wrap.toggleClass("expanded").hasClass("expanded");

                var ico = btn.find("i");
                ico.toggleClass("fa-chevron-down", !expanded).toggleClass("fa-chevron-up", expanded);

                btn.attr("aria-expanded", expanded ? "true" : "false");
            });

            // block flag for row click when time editor is clicked
            me.blockNextRowClick = false;
            me.myHtml.activityDayview.list.data.off("mousedown").on("mousedown", ".time-editor, .time-editor * , .time-cell .time-display", function () {
                me.blockNextRowClick = true;
            });


            me.myHtml.activityDayview.list.data.off("mousedown.timebtns").on("mousedown.timebtns", ".icon-time-ok, .icon-time-cancel", function () {
                me.blockNextRowClick = true;
            });


            // ticket popup on ticket cell click
            me.myHtml.activityDayview.list.data.off("click", ".ticket-cell").on("click", ".ticket-cell", function (e) {
                e.stopPropagation();

                const cell = $(this);
                const item = cell.closest(".vc-list-item");
                const idx = parseInt(item.attr("data-index"), 10);

                const rows = (me.myStatus.allDailyActivities.rows) || [];
                const row = rows[idx];
                if (!row) return;

                const ticketId = row.atid;
                const blid = row.blid;

                if (typeof me._openTicketFromActivity === "function") {
                    me._openTicketFromActivity(ticketId, blid);
                }
            });


            me.myHtml.activityDayview.list.data.off("click", ".time-cell .time-display").on("click", ".time-cell .time-display", function (e) {
                if (!me.flags.Editable) return;

                // we check, if the activity is already billed - if yes, we do not open the editor
                const rowItem = $(this).closest(".vc-list-item");
                const index = parseInt(rowItem.attr("data-index"), 10);
                const rows = (me.myStatus.allDailyActivities.rows) || [];
                const row = rows[index];
                if (!row) return;
                const hasAccounting = row.accountingtime != null && String(row.accountingtime).trim() !== "";
                if (row.billingdate || hasAccounting) { return;  }

                e.preventDefault();
                e.stopImmediatePropagation();

                const cell = $(this).closest(".time-cell");
                const editor = cell.find(".time-editor");
                const disp = cell.find(".time-display");

                // we close other open editors
                me.myHtml.activityDayview.list.data.find(".time-editor:visible").each(function () {
                    const otherCell = $(this).closest(".time-cell");
                    objActivityDayView._timeEditorCancel(me, otherCell);
                });

                cell.removeData("cancelled");

                // we store original values for cancel
                const idx = cell.closest(".vc-list-item").data("index");
                const r = (me.myStatus.allDailyActivities.rows || [])[idx] || {};
                cell.data("origStart", r.starttime || "");
                cell.data("origEnd", r.endtime || "");

                disp.hide();
                editor.show();
                editor.find(".time-start").focus().select();
            });
           

            // text editor - enter and escape handling for saving and cancelling
            me.myHtml.activityDayview.list.data.off("keydown", ".time-editor .time-input").on("keydown", ".time-editor .time-input", function (e) {
                const cell = $(this).closest(".time-cell");
                if (e.key === "Enter") {
                    e.preventDefault();
                    cell.removeData("cancelled");
                    objActivityDayView._timeEditorSave(me, cell);
                } else if (e.key === "Escape") {
                    e.preventDefault();
                    cell.data("cancelled", true);
                    objActivityDayView._timeEditorCancel(me, cell);
                }
                me.blockNextRowClick = false;
            });



            // OK button of time editor
            me.myHtml.activityDayview.list.data.off("click", ".icon-time-ok").on("click", ".icon-time-ok", function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                const cell = $(this).closest(".time-cell");
                cell.removeData("cancelled");
                objActivityDayView._timeEditorSave(me, cell);
                me.blockNextRowClick = false;
            });

            // Cancel of time editor
            me.myHtml.activityDayview.list.data.off("click", ".icon-time-cancel").on("click", ".icon-time-cancel", function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                const cell = $(this).closest(".time-cell");
                cell.removeData("cancelled");
                objActivityDayView._timeEditorCancel(me, cell);
                me.blockNextRowClick = false;
            });


        } catch (e) { me._writeErr(e); }        
    },


    

    _generateDayview: function (me) {
        /// <summary>
        /// This function fetches the daily activities for the selected date and fills the list
        /// </summary>
        try {
            var date = me.myHtml.activityDayview.menu.dateBox.calSingle.vcDate("getDate");

            me.dayReqId = (me.dayReqId || 0) + 1;
            const reqId = me.dayReqId;

            var list = me.myHtml.activityDayview.list.data;
            list.empty();
            me.myHtml.activityDayview.list.footer.empty();
            me.myStatus.allDailyActivities = [];


            // get daily activities for the selected date
            me.getData({ StartDate: date.from, EndDate: date.to, Interval: 1, SelectedMode: me.myStatus.selectedMode, FetchList: true }, function (result) {
                if (reqId !== me.dayReqId) return;

                if (result != null) {
                    list.empty(); // empty list again directly before refilling           
                    
                    let rows = result.rows || [];
                    me.myStatus.allDailyActivities.rows = rows;

                    if (rows.length === 0) {
                        // no activity is entered yet for the selected date - create "add row"
                        list.append(objActivityDayView._createAddRow(me, null, null));
                    } else {
                        // add "add row" at the beginning
                        list.append(objActivityDayView._createAddRow(me, null, rows[0].starttime));

                        let lastEndMin = null;
                        let lastEndStr = null;

                        for (let i = 0; i < rows.length; i++) {
                            const cur = rows[i];
                            const curStartMin = objActivityDayView._toMinutes(cur.starttime);
                            const curEndMin = objActivityDayView._toMinutes(cur.endtime);

                            // gap only if there is really a gap
                            if (lastEndMin !== null && Number.isFinite(curStartMin) && curStartMin > lastEndMin) {
                                list.append(objActivityDayView._createAddRow(me, lastEndStr, cur.starttime));
                            }

                            list.append(objActivityDayView._fillItems(me, i));

                            if (Number.isFinite(curEndMin)) {
                                if (lastEndMin === null || curEndMin > lastEndMin) {
                                    lastEndMin = curEndMin;
                                    lastEndStr = cur.endtime; 
                                }
                            }
                        }


                        if (lastEndStr) list.append(objActivityDayView._createAddRow(me, lastEndStr, null));                        
                        
                    }

                    // we only show the sum row if there are activities
                    if (rows.length > 0) {
                        me.myHtml.activityDayview.list.footer.empty().append(objActivityDayView._buildTotalRow(me));
                    } else {
                        me.myHtml.activityDayview.list.footer.empty();
                    }
                    objActivityDayView._setHeights(me);

                    objActivityDayView._formatTable(me);
                    objActivityDayView._markOverlaps(me); 
                    objActivityDayView._postProcessDescriptions(me);
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _createAddRow: function (me, fromTime, toTime) {
        /// <summary>
        /// This function creates a special "add row" for adding a new activity
        /// </summary>

        try {

            if (fromTime && toTime) {
                const a = objActivityDayView._toMinutes(fromTime);
                const b = objActivityDayView._toMinutes(toTime);
                if (!Number.isFinite(a) || !Number.isFinite(b) || !(a < b)) { return $(); }
            }

            var item = $("<div>", { "class": "vc-list-item vc-add-act-row noHover", "title": me.specific.resources.add });

            item.append($("<div>", { "class": "vc-list-col col0", "css": { "width": "8%" } }));
            item.append($("<div>", { "class": "vc-list-col col1", "css": { "width": "5%" } }));
            
            item.append($("<div>", { "class": "vc-list-col col3", "css": { "width": "12%" } }));
            item.append($("<div>", { "class": "vc-list-col col2", "css": { "width": "5%" } }));
             


            var label = (fromTime && toTime) ? me.specific.resources.add + " (" + fromTime + " – " + toTime + ")" : me.specific.resources.add;
            var col4 = $("<div>", { "class": "vc-list-col col4" }).css("width", "65%");
            var el4 = $("<div>", { "class": "vc-list-col-element" }).css({ display: "flex", justifyContent: "flex-start" });

            var btn = me._setObj("", "button-toggle btn-add-gap").html("<i class='fa fa-plus' style='margin-right:6px'></i>" + label).button();
            el4.append(btn);
            col4.append(el4);
            item.append(col4);

            item.append($("<div>", { "class": "vc-list-col col4" }).css("width", "5%"));

            btn.on("click", function (e) {
                e.stopPropagation();
                var date = me.myHtml.activityDayview.menu.dateBox.calSingle.vcDate("getDate");
                me.myStatus.editMode = false;
                me.myStatus.editAId = -1;
                objActivityEdit._addGapActivity(me, date, fromTime, toTime);
            });

            return item;
        } catch (e) {
            me.writeError('_createAddRow', e); return false;
        }
    },

    _fillItems: function (me, i) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        try {
            var item = $("<div>", { "class": "vc-list-item" });
            let obj = me.myStatus.allDailyActivities.rows;    

            const widths = { time: "8%" };
            const row = obj[i];
            const st = row.starttime || "";
            const et = row.endtime || "";

            const timeCol = $("<div>", { "class": "vc-list-col col0" }).css("width", widths.time);
            const timeEl = $("<div>", { "class": "vc-list-col-element" });

            // time cell with editor
            if (me.flags.Editable) {
                const html = ` <div class="time-cell" data-index="${i}"><span class="time-display">${st && et ? (st + " - " + et) : "&nbsp;"}</span>
                            <div class="time-editor" style="display:none">
                            <input type="text" class="time-input time-start no-row-edit" maxlength="5" value="${st}" placeholder="HH:MM" inputmode="numeric" />
                            <span class="time-sep">–</span>
                            <input type="text" class="time-input time-end no-row-edit"   maxlength="5" value="${et}" placeholder="HH:MM" inputmode="numeric" />
                            <i class="fa-solid fa-check icon-color-ok vc-list-icon icon-time-ok no-row-edit" title="${me.specific.resources.save}"></i>
                            <i class="fa-solid fa-xmark icon-color-error vc-list-icon icon-time-cancel no-row-edit" title="${me.specific.resources.cancel}"></i></div></div>`;
                timeEl.html(html);
            } else {
                timeEl.html(st && et ? (st + " - " + et) : "\u00A0");
            }

            timeCol.append(timeEl);
            item.append(timeCol);

            //item.append($("<div>", { "class": "vc-list-col col0" }).css("width", "8%").html($("<div>", { "class": "vc-list-col-element", "html": (obj[i].starttime + " - " + obj[i].endtime) })));
            item.append($("<div>", { "class": "vc-list-col col1" }).css("width", "5%").html($("<div>", { "class": "vc-list-col-element value num-right duration-cell", "html": objActivityDayView._durHours(obj[i]) })));
            item.append($("<div>", { "class": "vc-list-col col3" }).css("width", "12%").html($("<div>", { "class": "vc-list-col-element", "html": obj[i].device_name || "\u00A0" })));


            const ticketText = obj[i].ticketid || (obj[i].atid > 0 ? ("T" + obj[i].atid) : "");
            const col2 = $("<div>", { "class": "vc-list-col col2" }).css("width", "5%");
            const el2 = $("<div>", { "class": "vc-list-col-element no-row-edit" });

            if (ticketText) {
                const span = $("<span>", { "class": "ticket-cell ticket-link", "title": me.specific.resources.openTicket, "text": ticketText });
                el2.append(span);
            } else {                
                el2.html("\u00A0"); // no ticket
            }

            col2.append(el2);
            item.append(col2);      
            

            // add description with toggle button to show full text
            var col4 = $("<div>", { "class": "vc-list-col col4" }).css("width", "65%");
            var wrap = $("<div>", { "class": "vc-list-col-element desc-wrap", "html": obj[i].description });
            var toggle = $( '<button type="button" class="desc-toggle" aria-expanded="false" title="mehr anzeigen" style="display:none">' + '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>' +'</button>' );
            col4.append(wrap, toggle);
            item.append(col4);

            const col5 = $("<div>", { "class": "vc-list-col col5" }).css("width", "5%");
            const el5 = $("<div>", { "class": "vc-list-col-element" }).css({ display: "block", width: "100%", float: "none", "text-align": "right" });

            const hasBillingDate = !!row.billingdate;
            const hasAccounting = row.accountingtime != null && String(row.accountingtime).trim() !== "";
            if (!hasBillingDate && !hasAccounting) {
                el5.append($("<i>", { "class": "fa-solid fa-xmark icon-color-error icon-delete vc-list-icon", "data-index": i, "title": me.specific.resources.delete }));
            } else {
                el5.html("\u00A0"); // if already billed, no delete icon
            }

            col5.append(el5);
            item.append(col5);

            item.attr("data-index", i);
            return item;
        } catch (e) { me.writeError('_fillItems', e); return false; }
    },

    _formatTable: function (me) {
        /// <summary>
        /// This function formats the table
        /// </summary>
        try {
            var list = me.fnd('.lst-day-entries');
            list.find('.vc-list-item:even').addClass('alt');
            list.find('.vc-list-item .vc-list-col-element.value').formatDouble(2);

            var rows = (me.myStatus.allDailyActivities.rows) || [];

            list.find('.vc-list-item').each(function () {
                var item = $(this);
                var idx = parseInt(item.attr('data-index'), 10);
                if (isNaN(idx)) return; // we ignore rows without index (e.g. add row)

                var row = rows[idx];
                if (!row) return;

                const hasBillingDate = !!row.billingdate;
                const hasAccounting = row.accountingtime != null && String(row.accountingtime).trim() !== "";

                // if already billed, we skip
                if (!hasBillingDate && !hasAccounting) return;

                var cell = item.find('.vc-list-col-element.duration-cell');
                if (!cell.length) return;

                var content = cell.html();
                if (!content || !content.trim()) return;

                var iconHtml = '<i class="billing-icon" ' + 'title="' + me.specific.resources.alreadyBilled + '" aria-hidden="true">(€)</i>';

                cell.html(iconHtml + ' ' + content);
            });


        } catch (e) { me.writeError('_formatTable', e); }
    },

    _postProcessDescriptions: function (me) {
        /// <summary>
        /// This function post-processes the description fields to check for truncation and set corresponding classes
        /// </summary>
        try {
            // we check all description fields, if they are truncated (with "…") and set a corresponding class
            me.fnd(".lst-day-entries .desc-wrap").each(function () {
                var elem = this;
                var el = $(elem);
                var isTruncated = elem.scrollHeight > elem.clientHeight + 1;
                el.toggleClass("truncated", isTruncated);

                var btn = el.next(".desc-toggle");
                btn.toggle(isTruncated);

                if (!isTruncated) {
                    el.removeClass("expanded");
                    var icon = btn.find("i");
                    icon.removeClass("fa-chevron-up").addClass("fa-chevron-down");
                    btn.attr("aria-expanded", "false");
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _markOverlaps: function (me) {
        /// <summary>
        /// This function marks overlapping activities
        /// </summary>
        try {
            // we remove old overlap markers
            me.fnd('.lst-day-entries .vc-list-item.overlap').removeClass('overlap');

            const rows = (me.myStatus.allDailyActivities && me.myStatus.allDailyActivities.rows) || [];
            if (!rows.length) return;

            // we calculate everything on minute base
            const toMin = (t) => {
                if (!t || typeof t !== "string") return NaN;
                const m = /^(\d{1,2}):([0-5]\d)$/.exec(t.trim());
                if (!m) return NaN;
                return (+m[1]) * 60 + (+m[2]);
            };

            
            const intervals = [];
            for (let i = 0; i < rows.length; i++) {
                const s = toMin(rows[i].starttime);
                const e = toMin(rows[i].endtime);
                if (Number.isFinite(s) && Number.isFinite(e) && e > s) {
                    intervals.push({ i, start: s, end: e });
                }
            }
            if (!intervals.length) return;

            // we sort everything from start to end
            intervals.sort((a, b) => a.start - b.start);

            // we check, if it is a real item or a "gap item"
            let active = [];
            const mark = (idx) => {                
                me.fnd(`.lst-day-entries .vc-list-item[data-index="${idx}"]`).addClass('overlap');
            };

            for (const cur of intervals) {
                active = active.filter(a => a.end > cur.start);

                if (active.length) {
                    mark(cur.i);
                    active.forEach(a => mark(a.i));
                }

                active.push(cur);
            }
        } catch (e) { me._writeErr(e); }
    },


    _calcTotalWorkMinutes: function (me) {
        /// <summary>
        /// This function calculates the total work minutes from all activities
        /// </summary>
        try {
            const rows = (me.myStatus.allDailyActivities.rows) || [];
            let total = 0;
            for (const r of rows) {
                const sm = objActivityDayView._toMinutes(r.starttime);
                const em = objActivityDayView._toMinutes(r.endtime);
                if (sm != null && em != null && em >= sm) {
                    total += (em - sm);
                }
            }
            return total; // in minutes
        } catch (e) { me._writeErr(e); return 0; }
    },

    _buildTotalRow: function (me) {
        try {
            // calculate total hours in hours with 2 decimal places
            const totalMin = objActivityDayView._calcTotalWorkMinutes(me);
            const totalHours = totalMin / 60;
            const totalTxt = new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                useGrouping: false
            }).format(totalHours);

            const widths = ["8%", "5%", "12%", "5%", "65%", "5%"];
            const item = $("<div>", { "class": "vc-list-item total-row" });

            const col0 = $("<div>", { "class": "vc-list-col col0" }).css("width", widths[0]).html($("<div>", { "class": "vc-list-col-element", "text": me.specific.resources.sum }));
            item.append(col0);

            const col1 = $("<div>", { "class": "vc-list-col col1" }).css("width", widths[1]).html($("<div>", { "class": "vc-list-col-element value num-right", "text": totalTxt }));
            item.append(col1);

            const col3 = $("<div>", { "class": "vc-list-col col3" }).css("width", widths[3]).html($("<div>", { "class": "vc-list-col-element", html: "&nbsp;" }));
            item.append(col3);

            const col2 = $("<div>", { "class": "vc-list-col col2" }).css("width", widths[2]).html($("<div>", { "class": "vc-list-col-element", html: "&nbsp;" }));
            item.append(col2);            

            const col4 = $("<div>", { "class": "vc-list-col col4" }).css("width", widths[4]).html($("<div>", { "class": "vc-list-col-element", html: "&nbsp;" }));
            item.append(col4);

            return item;
        } catch (e) { me.writeError('_buildTotalRow', e); return $(); }
    },


    _durHours: function (r) {
        /// <summary>
        /// This function calculates the duration in hours between start and end times
        /// </summary>
        try {
            var sm = objActivityDayView._toMinutes(r.starttime);
            var em = objActivityDayView._toMinutes(r.endtime);
            if (sm == null || em == null || em < sm) return "&nbsp;";
            var h = (em - sm) / 60;
            return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false }).format(h);
        } catch (e) { me._writeErr(e); return false; }
    },

    _toMinutes: function (t) {
        if (!t || typeof t !== "string") return NaN;
        const m = /^(\d{1,2}):([0-5]\d)$/.exec(t.trim());
        if (!m) return NaN;
        return (+m[1]) * 60 + (+m[2]);
    },


    _timePattern: /^([01]?\d|2[0-3]):([0-5]\d)$/,

    _normTime: function (t) {
        if (typeof objActivityValidation !== "undefined" && typeof objActivityValidation._normalizeTimeSmart === "function") {
            const norm = objActivityValidation._normalizeTimeSmart(String(t || "").trim());
            return norm || String(t || "").trim();
        }
        const s = String(t || "").trim();
        const m = /^(\d{1,2}):(\d{1,2})$/.exec(s);
        if (!m) return s;
        const hh = ("0" + m[1]).slice(-2);
        const mm = ("0" + m[2]).slice(-2);
        return `${hh}:${mm}`;
    },

    _valTime: function (t) {
        return objActivityDayView._timePattern.test(String(t || "").trim());
    },

    _markTimeInputsError: function (cell, badStart, badEnd, badOrder) {
        const s = cell.find(".time-start"), e = cell.find(".time-end");
        s.toggleClass("error", !!badStart);
        e.toggleClass("error", !!badEnd || !!badOrder);
        if (badOrder) {
            const title = (cell.data("order-msg")) || "Endzeit liegt vor Startzeit.";
            e.attr("title", title);
        } else {
            e.removeAttr("title");
        }
    },

    _timeEditorCancel: function (me, cell) {
        /// <summary>
        /// This function cancels the time editor and restores original values
        /// </summary>
        try {
            cell.data("cancelled", true);
            const idx = parseInt(cell.attr("data-index"), 10);
            const rows = (me.myStatus.allDailyActivities.rows || []);
            const r = rows[idx] || {};
            const disp = cell.find(".time-display");
            const editor = cell.find(".time-editor");

            const st = (cell.data("origStart") != null) ? cell.data("origStart") : (r.starttime || "");
            const et = (cell.data("origEnd") != null) ? cell.data("origEnd") : (r.endtime || "");

            editor.find(".time-start").val(st);
            editor.find(".time-end").val(et);
            disp.text(st && et ? (st + " - " + et) : "\u00A0");

            editor.hide();
            disp.show();

            objActivityDayView._markTimeInputsError(cell, false, false, false);
            cell.removeData("origStart").removeData("origEnd");
            me.blockNextRowClick = false;
        } catch (e) { me._writeErr(e); }
    },

    _timeEditorSave: function (me, cell, silentFail) {
        /// <summary>
        /// This function saves the time editor values
        /// </summary>
        try {
            const editor = cell.find(".time-editor");
            if (!editor.is(":visible")) return;
            if (cell.data("cancelled")) return;

            const idx = parseInt(cell.attr("data-index"), 10);
            const rows = (me.myStatus.allDailyActivities.rows) || [];
            const row = rows[idx];
            if (!row) return;

            const disp = cell.find(".time-display");

            // we validate inputs and save changes
            let st = editor.find(".time-start").val();
            let et = editor.find(".time-end").val();

            st = objActivityDayView._normTime(st);
            et = objActivityDayView._normTime(et);
            editor.find(".time-start").val(st);
            editor.find(".time-end").val(et);

            const badStart = !objActivityDayView._valTime(st);
            const badEnd = !objActivityDayView._valTime(et);
            const sm = objActivityDayView._toMinutes(st);
            const em = objActivityDayView._toMinutes(et);
            const badOrder = (sm == null || em == null) ? (badStart || badEnd) : (em < sm);

            if (badStart || badEnd || badOrder) {
                objActivityDayView._markTimeInputsError(cell, badStart, badEnd, badOrder);
                if (!silentFail) { alert(badOrder ? me.specific.resources.endtimeIsBeforeStarttime : me.specific.resources.inputIncomplete); } return;
            }
            objActivityDayView._markTimeInputsError(cell, false, false, false);

            const dateObj = me.myHtml.activityDayview.menu.dateBox.calSingle.vcDate("getDate");
            const dateFrom = dateObj && (dateObj.from || dateObj.to);
            const theDate = row.date || dateFrom;

            // we prepare parameters for saving - we need all data of the row for correct saving
            const param = {
                Id: row.id,
                changeTypeId: 2,
                Date: theDate,
                StartTime: st,
                EndTime: et,
                Description: row.description,
                UserId: row.uid,
                ProjectId: row.pid,
                BdId: row.bdid,
                TicketId: row.atid,
                IsPublic: row.isPublic,
                Done: row.done,
                Cleared: row.cleared,
                Km: row.km,
                MarkUnread: false,
                Arrival: row.arrival,
                Blid: row.blid,
                Charge: row.charge
            };

            me.updateData(param, function (result) {
               
                row.starttime = st;
                row.endtime = et;

                // we save the scroll position
                const listEl = me.myHtml.activityDayview.list.data;
                const keepScroll = listEl.scrollTop();

                // we update the whole view, so that gap buttons etc are correct
                objActivityDayView._generateDayview(me);

                setTimeout(function () { me.myHtml.activityDayview.list.data.scrollTop(keepScroll); }, 0);

                cell.removeData("cancelled").removeData("origStart").removeData("origEnd");
                me.blockNextRowClick = false;
            });
        } catch (e) { me._writeErr(e); }
    },




};